import React from 'react'
import { Link } from "gatsby"
import boxStyle from "../components/css/box.module.scss";

export default function({label, img}){

    return(
        <div className={boxStyle.boxContainer}>
            <div className={boxStyle.cover} style={{backgroundImage: "url('http://api.vanarts.com/assets/"+img+"')" }}></div>
            <div className={boxStyle.box}>
            <Link to="/">{label}</Link>
            </div> 
        </div>
    )
}